import { VFC, useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Resistance } from '@enmon/commons';
import { Select } from '../../Select';
import { MeterDetails as messages } from '../../../Form/meter_details/messages';
import { resistanceTranslated } from '../../../Form/meter_details/constants';
import { useMeterModelSuggestionsStore } from '../../../../store/useMeterModelSuggestionsStore';
import { getSelectOptionsWithSuggestions } from '../../utils/getSelectOptionsWithSuggestions';

interface ResistanceSelectProps {
  value?: Resistance;
  onChange?: (value: Resistance) => void;
}

export const ResistanceSelect: VFC<ResistanceSelectProps> = ({ ...restProps }) => {
  const intl = useIntl();
  const { meterModelSuggestions } = useMeterModelSuggestionsStore();

  const resistanceOptions = useMemo(
    () =>
      getSelectOptionsWithSuggestions({
        intl,
        values: Object.values(Resistance),
        suggestedValue: meterModelSuggestions?.resistance?.value,
        suggestedSelection: meterModelSuggestions?.resistance?.selection,
        labelFormatter: (value: Resistance) => resistanceTranslated[value],
      }),
    [intl, meterModelSuggestions],
  );

  return (
    <Select
      allowClear
      showArrow
      className="w-100"
      options={resistanceOptions}
      placeholder={<FormattedMessage {...messages.resistancePlaceholder} />}
      {...restProps}
    />
  );
};
